import React from "react";
import "../../css/InfoBanner.css";
import { strings } from "../../resources/Strings";

const InfoBanner = () => {
  return (
    <div className="bannerWrapper text-left">
      <h3>{strings.infoBanner.nowYou}</h3>
      <div className="ul-wrapper">
        <ul>
          <li>
            <div align="absmiddle" className="icon img1" />
            <span>{strings.infoBanner.text1}</span>
          </li>
          <li>
            <div align="absmiddle" className="icon img2" />
            <span>{strings.infoBanner.text2}</span>
          </li>
          <li>
            <div align="absmiddle" className="icon img3" />
            <span>{strings.infoBanner.text3}</span>
          </li>
          {/*<li>
            <div align="absmiddle" className="icon img4" />
            <span>{strings.infoBanner.text4}</span>
          </li>*/}
          <li>
            <div align="absmiddle" className="icon img5" />
            <span>{strings.infoBanner.text5}</span>
          </li>
        </ul>
      </div>
      {/*<p>*/}
      {/*  {strings.formatString(*/}
      {/*    strings.infoBanner.youCan,*/}
      {/*    <span className="mobileLink">{strings.infoBanner.mobileAppText}</span>*/}
      {/*  )}*/}
      {/*</p>*/}
    </div>
  );
};

export default InfoBanner;
